module.exports = __webpack_public_path__ + "static/media/Window-1.2085550d.svg";